<template>
	<div class="tcp-page tcp-product-page">
		<section class="tcp-shop__wrap" v-if="product">
			<nav class="tcp-crumbs">
				<router-link to="/">Home</router-link>
				<span>/</span>
				<router-link to="/shop">Shop</router-link>
				<template v-if="primaryCategory">
					<span>/</span>
					<router-link :to="'/shop?category=' + (primaryCategory.slug || primaryCategory.id)">{{ primaryCategory.name }}</router-link>
				</template>
				<span>/</span>
				<span>{{ product.name }}</span>
			</nav>

			<div class="tcp-product">
				<div>
					<div class="tcp-product__stage">
						<img v-if="activeImage" :src="activeImage" :alt="product.name">
						<span v-else class="tcp-card__placeholder"><i class="fa fa-box"></i></span>
					</div>
					<div v-if="images.length > 1" class="tcp-thumbs">
						<button
							v-for="(image, index) in images"
							:key="index"
							type="button"
							:class="{ 'is-active': activeImage === image }"
							@click="activeImage = image"
						>
							<img :src="image" :alt="product.name">
						</button>
					</div>
				</div>

				<div class="tcp-product__info">
					<p v-if="product.presentation" class="tcp-shop-card__kicker">{{ product.presentation }}</p>
					<h1>{{ product.name }}</h1>
					<p v-if="product.excerpt" class="tcp-product__lead">{{ product.excerpt }}</p>
					<p class="tcp-price">{{ money(product.price) }}</p>
					<p class="tcp-stock" :class="{ 'is-out': !available }">
						{{ available ? product.stock + ' in stock' : 'Sold out' }}
					</p>

					<div class="tcp-stepper" v-if="available">
						<p>Quantity</p>
						<div>
							<button type="button" aria-label="Decrease" @click="changeQty(-1)"><i class="fa fa-minus"></i></button>
							<span>{{ quantity }}</span>
							<button type="button" aria-label="Increase" @click="changeQty(1)"><i class="fa fa-plus"></i></button>
						</div>
					</div>

					<button type="button" class="tcp-btn tcp-product__add" :disabled="!available" @click="add">
						{{ available ? 'Add to Cart' : 'Sold out' }}
					</button>
					<p v-if="added" class="tcp-note">Added to cart. <router-link to="/cart">View cart</router-link></p>

					<div class="tcp-product__ship">
						<strong>Free shipping</strong> on orders over $100 USD
					</div>
				</div>
			</div>

			<div class="tcp-product__details">
				<div v-if="product.description">
					<h2>Description</h2>
					<p>{{ product.description }}</p>
				</div>
				<div v-if="benefits.length">
					<h2>Key Benefits</h2>
					<ul>
						<li v-for="(benefit, index) in benefits" :key="index">{{ benefit }}</li>
					</ul>
				</div>
				<div v-if="product.ingredients">
					<h2>Ingredients</h2>
					<p>{{ product.ingredients }}</p>
				</div>
				<div v-if="product.usage">
					<h2>How to Use</h2>
					<p>{{ product.usage }}</p>
				</div>
			</div>
		</section>

		<section v-else-if="!loading" class="tcp-shop__wrap tcp-product__missing">
			<p class="tcp-empty">This product is not available.</p>
			<router-link to="/shop" class="tcp-btn">Back to shop</router-link>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			product: null,
			activeImage: null,
			quantity: 1,
			added: false,
			loading: true
		}
	},
	computed: {
		available() {
			return this.product && Number(this.product.stock) > 0 && this.product.status !== 'Agotado'
		},
		primaryCategory() {
			return this.product && this.product.categories && this.product.categories.length ? this.product.categories[0] : null
		},
		images() {
			if (!this.product) return []
			const list = []
			if (this.product.image_url) list.push(this.product.image_url)
			;(this.product.gallery || []).forEach(url => {
				if (list.indexOf(url) === -1) list.push(url)
			})
			return list
		},
		benefits() {
			if (!this.product || !this.product.key_benefits) return []
			return this.product.key_benefits.split(/\r?\n|,/).map(item => item.trim()).filter(Boolean)
		}
	},
	methods: {
		money(value) {
			return '$' + Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		},
		load() {
			this.loading = true
			this.product = null
			this.added = false
			axios.get(tools.url('/api/store/products/' + this.$route.params.id)).then((response) => {
				this.product = response.data
				this.activeImage = response.data.image_url || ((response.data.gallery || [])[0] || null)
				this.quantity = 1
				this.loading = false
				if (response.data && response.data.name) {
					document.title = response.data.name + ' - The Conscious Pantry'
				}
			}).catch(() => {
				this.loading = false
			})
		},
		changeQty(step) {
			const max = Math.max(1, Number(this.product.stock) || 1)
			this.quantity = Math.min(max, Math.max(1, this.quantity + step))
		},
		add() {
			if (!this.available) return
			const qty = Math.max(1, Math.min(Number(this.product.stock), Number(this.quantity) || 1))
			this.$cart.add(this.product, qty)
			this.added = true
		}
	},
	watch: {
		'$route.params.id'() {
			this.load()
		}
	},
	mounted() {
		this.load()
	}
}
</script>
